import { Injectable } from "@angular/core";
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LatitudeLongitudeService {
    private originAddressSubject = new Subject<any>();
    private setDestinationMarkerSubject = new Subject<boolean>();
    serviceName: "";
    subServiceName: "";
    maintenanceName: "";
    towingSelected: boolean = false;
    currentLatitude: any;
    currentLongitude: any;
    streetAddress: any = "";
    city: any = "";
    state: any = "";
    country: any = "";
    zip: any = 0;
    destinationCity: any = "";
    destinationCurrentLatitude: any = null;
    destinationCurrentLongitude: any = null;
    destinationStreetAddress: any = "";
    destinationState: any = "";
    destinationCountry: any = "";
    destinationZip: any = 0;
    formattedDestinationAddress: any = "";
    forattedAddress: any = "";
    showRoute: boolean = false;
    vehicleType: any;
    maintenancePlan: string;
    serviceQuestion: any;
    vendorCount: any;
    additionalInstructions: any;
    tireData: any;
    newWOId: any = 0;
    servicingUnit: any;
    appointmentTime: any;
    appointmentNote: any;
    trailerDestination: boolean;
    trailerDestinationLat: any;
    trailerDestinationLong: any;
    trailerDestinationMarker: boolean;
    showTrailerDest: boolean;
    destinationTrailerStreetAddress: any = "";
    destinationTrailerState: any = "";
    destinationTrailerCountry: any = "";
    destinationTrailerZip: any = 0;
    destinationTrailerCity: any = "";
    formattedTrailerAddress: any;
    vehicleTypeName: any;
    vehicleMake: any;
    trailerMake: any;
    shopAddress: any;
    shopFlag = false;

    shipToAddressKey: any;
    subCustomerKey: any;

    // For driver info
    driverFirstName: any;
    driverLastName: any;
    driverPhoneNumber: any;

    //Attachment File
    AttachmentFile: File;
    attachmentPurpose: any;

    // winter Strom
    isWinterStrom: boolean;
    serviceTypeQuestion: any;
    customerServiceTypeQuestion: any;

    setDriverInfo(infoName = null, infoValue = "") {
        if (infoName) {
            if (infoName == 'driverFirstName') {
                this.driverFirstName = infoValue;
            }

            if (infoName == 'driverLastName') {
                this.driverLastName = infoValue;
            }

            if (infoName == 'driverPhoneNumber') {
                this.driverPhoneNumber = infoValue;
            }
        }
    }

    getDriverInfo(info = null) {
        let driverInfo = "";

        if (info == 'driverFirstName') {
            driverInfo = this.driverFirstName;
        }

        if (info == 'driverLastName') {
            driverInfo = this.driverLastName;
        }

        if (info == 'driverPhoneNumber') {
            driverInfo = this.driverPhoneNumber;
        }

        return driverInfo;
    }

    setServiceTypeQuestion(serviceTypeQuestion) {
        this.serviceTypeQuestion = serviceTypeQuestion;
    }

    getServiceTypeQuestion() {
        return this.serviceTypeQuestion;
    }

    setCustomerServiceTypeQuestion(customerServiceTypeQuestion) { this.customerServiceTypeQuestion = customerServiceTypeQuestion; }
    getCustomerServiceTypeQuestion() { return this.customerServiceTypeQuestion; }
  

    setServiceName(serviceName) {
        this.serviceName = serviceName;
    }

    getServiceName() {
        return this.serviceName;
    }

    setSubServiceName(subServiceName) {
        this.subServiceName = subServiceName;
    }

    getSubServicename() {
        return this.subServiceName;
    }

    setMaintenanceName(maintenanceName) {
        this.maintenanceName = maintenanceName;
    }

    getMainteanceName() {
        return this.maintenanceName;
    }

    setTowingSelected(flag) {
        this.towingSelected = flag;
    }

    getTowingSelected() {
        return this.towingSelected;
    }

    setCountry(country) {
        this.country = country;
    }

    getCountry() {
        return this.country;
    }

    setLatitude(lat) {
        this.currentLatitude = lat;
    }

    getLatitude() {
        return this.currentLatitude;
    }

    setLongitude(lng) {
        this.currentLongitude = lng;
    }

    getLongitude() {
        return this.currentLongitude;
    }

    setCity(city) {
        this.city = city;
    }

    getCity() {
        return this.city;
    }

    setState(state) {
        this.state = state;
    }

    getState() {
        return this.state;
    }
    setZip(zip) {
        this.zip = zip;
    }

    getZip() {
        return this.zip;
    }

    setStreetAddress(street) {
        this.streetAddress = street;
    }

    getStreetAddress() {
        return this.streetAddress;
    }

    // setter & getter for formatted address of origin location
    setFormattedOriginAddress(address) {
        this.originAddressSubject.next({ formattedOriginAddress: address });
    }

    getFormattedOriginAddress() {
        return this.originAddressSubject.asObservable();
    }

    // set destination marker
    setDestinationMarker(status: boolean) {
        this.setDestinationMarkerSubject.next(status);
    }

    getDestinationMarker() {
        return this.setDestinationMarkerSubject.asObservable();
    }

    //for destination
    setDestinationCountry(country) {
        this.destinationCountry = country;
    }

    getDestinationCountry() {
        return this.destinationCountry;
    }

    setDestinationLatitude(lat) {
        this.destinationCurrentLatitude = lat;
    }

    getDestinationLatitude() {
        return this.destinationCurrentLatitude;
    }

    setDestinationLongitude(lng) {
        this.destinationCurrentLongitude = lng;
    }

    getDestinationLongitude() {
        return this.destinationCurrentLongitude;
    }

    setDestinationCity(city) {
        this.destinationCity = city;
    }

    getDestinationCity() {
        return this.destinationCity;
    }
    setDestinationState(state) {
        this.destinationState = state;
    }

    getDestinationState() {
        return this.destinationState;
    }
    setDestinationZip(zip) {
        this.destinationZip = zip;
    }

    getDestinationZip() {
        return this.destinationZip;
    }
    setDestinationStreetAddress(street) {
        this.destinationStreetAddress = street;

    }

    getDestinationStreetAddress() {
        return this.destinationStreetAddress;
    }

    setVehivleType(vehicleType) {
        this.vehicleType = vehicleType;
    }

    getVehicleType() {
        return this.vehicleType;
    }

    resetServicesNames() {
        this.serviceName = "";
        this.subServiceName = "";
        this.maintenanceName = "";
    }

    clearMarker() {
        this.currentLatitude = null;
        this.currentLongitude = null;
        this.destinationCurrentLatitude = null;
        this.destinationCurrentLongitude = null;
        this.formattedDestinationAddress = null;
        this.formattedTrailerAddress = null;
        this.forattedAddress = null;
    }

    setMaintPlan(maintenancePlan) {
        this.maintenancePlan = maintenancePlan;
    }

    getMaintPlan() {
        return this.maintenancePlan;
    }

    setserviceQuestion(serviceQuestion) {
        this.serviceQuestion = serviceQuestion;
    }

    getserviceQuestion() {
        return this.serviceQuestion;
    }

    setVendorCount(vendorCount) {
        this.vendorCount = vendorCount;
    }

    getVendorCount() {
        return this.vendorCount;
    }

    setAdditionalInstructions(additionalInstructions) {
        this.additionalInstructions = additionalInstructions;
    }

    getAdditionalInstructions() {
        return this.additionalInstructions;
    }

    setTireData(tireData) {
        this.tireData = tireData;
    }

    getTireData() {
        return this.tireData;
    }

    setNewWOId(newWOId) {
        this.newWOId = newWOId;
    }

    getNewWOId() {
        return this.newWOId;
    }

    setServicingUnit(servicingUnit) {
        this.servicingUnit = servicingUnit;
    }

    getServicingUnit() {
        return this.servicingUnit;
    }

    setAppointmentTime(appointmentTime) {
        this.appointmentTime = appointmentTime;
    }

    getAppointmentTime() {
        return this.appointmentTime;
    }

    setAppointmentNote(appointmentNote) {
        this.appointmentNote = appointmentNote;
    }

    getAppointmentNote() {
        return this.appointmentNote;
    }

    setTrailerDestinationLat(trailerDestinationLat) {
        this.trailerDestinationLat = trailerDestinationLat;
    }

    getTrailerDestinationLat() {
        return this.trailerDestinationLat;
    }

    setTrailerDestinationLong(trailerDestinationLong) {
        this.trailerDestinationLong = trailerDestinationLong;
    }

    gettrailerDestinationLong() {
        return this.trailerDestinationLong;
    }

    setTrailerDestinationMarker(trailerDestinationMarker) {
        this.trailerDestinationMarker = trailerDestinationMarker;
    }

    getTrailerDestinationMarker() {
        return this.trailerDestinationMarker;
    }

    setTrailerDestination(trailerDestination) {
        this.trailerDestination = trailerDestination;
    }

    getTrailerDestination() {
        return this.trailerDestination;
    }

    //for Trailer destination
    setDestinationTrailerCountry(country) {
        this.destinationTrailerCountry = country;
    }

    getDestinationTrailerCountry() {
        return this.destinationTrailerCountry;
    }

    setDestinationTrailerCity(city) {
        this.destinationTrailerCity = city;
    }

    getDestinationTrailerCity() {
        return this.destinationTrailerCity;
    }
    setDestinationTrailerState(state) {
        this.destinationTrailerState = state;
    }

    getDestinationTrailerState() {
        return this.destinationTrailerState;
    }
    setDestinationTrailerZip(zip) {
        this.destinationTrailerZip = zip;
    }

    getDestinationTrailerZip() {
        return this.destinationTrailerZip;
    }

    setDestinationTrailerStreetAddress(street) {
        this.destinationTrailerStreetAddress = street;
    }
    getDestinationTrailerStreetAddress() {
        return this.destinationTrailerStreetAddress;
    }

    setVehicleTypeName(vehicleTypeName) {
        this.vehicleTypeName = vehicleTypeName;
    }

    getVehicleTypeName() {
        return this.vehicleTypeName;
    }

    setVehicleMake(vehicleMake) {
        this.vehicleMake = vehicleMake;
    }

    getVehicleMake() {
        return this.vehicleMake;
    }

    setTrailerMake(trailerMake) {
        this.trailerMake = trailerMake;
    }

    getTrailerMake() {
        return this.trailerMake;
    }

    setShopAddress(shopAddress) {
        this.shopAddress = shopAddress;
    }

    getShopAddress() {
        return this.shopAddress;
    }

    setShopFlag(flag) {
        this.shopFlag = flag;
    }

    getShopFlag() {
        return this.shopFlag;
    }

    setShipToAddressKey(shipToAddressKey) {
        this.shipToAddressKey = shipToAddressKey;
    }
    getShipToAddressKey() {
        return this.shipToAddressKey;
    }
    setSubCustomerKey(subCustomerKey) {
        this.subCustomerKey = subCustomerKey;
    }
    getSubCustomerKey() {
        return this.subCustomerKey;
    }

    setAttachmentFile(AttachmentFile, purpose) {
        this.AttachmentFile = AttachmentFile;
        this.attachmentPurpose = purpose;
    }

    getAttachmentFile() {
        return this.AttachmentFile;
    }

    getAttachmentPurpose() {
        return this.attachmentPurpose;
    }

    setIsWinterStrom(isWinterStrom) {
        this.isWinterStrom = isWinterStrom;
    }

    getIsWinterStrom() {
        return this.isWinterStrom;
    }
}
